export default __webpack_public_path__ + "static/media/bg.b640c7f4.jpg";